module.exports = __webpack_public_path__ + "static/img/about.49b55ee6.png";